var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "roles" } },
    [
      _c("supsis-table", {
        attrs: {
          columns: _vm.cols,
          rows: _vm.currentPageData,
          "bottom-pagination": true,
          "pagination-cursor": _vm.paginationCursor,
        },
        on: {
          "cursor-changed": function (cursor) {
            return (_vm.paginationCursor = cursor)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center",
                  },
                  [
                    _c("a-input-search", {
                      staticClass: "search-input",
                      attrs: { placeholder: _vm.$t("message.startFilter") },
                      on: { search: _vm.onSearch },
                      model: {
                        value: _vm.searchText,
                        callback: function ($$v) {
                          _vm.searchText = $$v
                        },
                        expression: "searchText",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { ghost: "" },
                        on: { click: _vm.openCreateFormModal },
                      },
                      [
                        _c("md-icon", [_vm._v("add")]),
                        _vm._v(_vm._s(_vm.$t("message.createRole"))),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.isModalShow
        ? _c(
            "Modal2",
            {
              staticStyle: { "overflow-x": "auto", "overflow-y": "hidden" },
              attrs: {
                id: "role-form",
                title: _vm.editMode
                  ? _vm.$t("message.updateRoleForm")
                  : _vm.$t("message.newRoleForm"),
                "show-footer": false,
              },
              on: { cancel: _vm.hideModal },
            },
            [
              _vm.$validator.errors.items.length
                ? _c(
                    "a-alert",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        message: _vm.$t("message.error"),
                        showIcon: "",
                        type: "error",
                      },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "description" }, slot: "description" },
                        _vm._l(_vm.$validator.errors.items, function (err) {
                          return _c("div", { key: err.id }, [
                            _c("span", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(err.msg) +
                                  "\n                    "
                              ),
                            ]),
                          ])
                        }),
                        0
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-form",
                {
                  staticClass: "d-flex flex-column justify-content-center",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.duplicateControl.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "b-row",
                    { staticClass: "mb-3" },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c("b-form-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                            ],
                            attrs: {
                              id: "display-name-input",
                              name: _vm.$t("message.roleName"),
                              placeholder: _vm.$t("message.roleName"),
                              autocomplete: "off",
                              trim: "",
                              type: "text",
                            },
                            model: {
                              value: _vm.role.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.role, "name", $$v)
                              },
                              expression: "role.name",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "a-checkbox",
                            {
                              attrs: {
                                checked: _vm.isEveryIncludes(
                                  _vm.permissions.map(function (x) {
                                    return x._id
                                  })
                                ),
                                indeterminate: _vm.isSomeIncludes(
                                  _vm.permissions.map(function (x) {
                                    return x._id
                                  })
                                ),
                              },
                              on: { click: _vm.selectAll },
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "col-form-label",
                                  on: { click: _vm.selectAll },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("message.selectAllPermission")
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c(
                            "b-row",
                            _vm._l(
                              _vm.groupedPermissions,
                              function (permissions, index) {
                                return _c(
                                  "b-col",
                                  { key: index, attrs: { md: "12" } },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "groupTitle" },
                                          [
                                            _c(
                                              "a-checkbox",
                                              {
                                                attrs: {
                                                  checked: _vm.isEveryIncludes(
                                                    permissions.map(function (
                                                      x
                                                    ) {
                                                      return x._id
                                                    })
                                                  ),
                                                  indeterminate:
                                                    _vm.isSomeIncludes(
                                                      permissions.map(function (
                                                        x
                                                      ) {
                                                        return x._id
                                                      })
                                                    ),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.groupClicked(
                                                      index,
                                                      permissions.map(function (
                                                        x
                                                      ) {
                                                        return x._id
                                                      })
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.groupClicked(
                                                          index,
                                                          permissions.map(
                                                            function (x) {
                                                              return x._id
                                                            }
                                                          )
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    permissions.length > 0 &&
                                                    _vm.PERMISSION_TYPES[
                                                      permissions[0].name
                                                    ] !== undefined
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                                                " +
                                                              _vm._s(
                                                                _vm
                                                                  .PERMISSION_TYPES[
                                                                  permissions[0]
                                                                    .name
                                                                ][
                                                                  _vm.$i18n
                                                                    .locale
                                                                ].entity
                                                              )
                                                          ),
                                                        ])
                                                      : _c("span", [
                                                          _vm._v(_vm._s(index)),
                                                        ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "md-button",
                                              {
                                                staticStyle: {
                                                  width: "0px",
                                                  "min-width": "32px",
                                                  margin: "0",
                                                  height: "100%",
                                                  "background-color": "#f3f6f9",
                                                  flex: "1",
                                                },
                                                attrs: { id: "mdButton" },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.toggles[index] =
                                                      !_vm.toggles[index]
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "md-icon",
                                                  {
                                                    staticStyle: {
                                                      margin: "0",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            keyboard_arrow_" +
                                                        _vm._s(
                                                          _vm.toggles[index]
                                                            ? "up"
                                                            : "down"
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.toggles[index]
                                          ? _c("b-form-checkbox-group", {
                                              staticClass: "mx-3 mb-3",
                                              attrs: {
                                                options: permissions.map(
                                                  function (p) {
                                                    return {
                                                      text: _vm
                                                        .PERMISSION_TYPES[
                                                        p.name
                                                      ]
                                                        ? _vm.PERMISSION_TYPES[
                                                            p.name
                                                          ][_vm.$i18n.locale]
                                                            .description
                                                        : p.description,
                                                      value: p._id,
                                                    }
                                                  }
                                                ),
                                                name: "permissions",
                                                stacked: "",
                                              },
                                              model: {
                                                value: _vm.role.permissions,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.role,
                                                    "permissions",
                                                    $$v
                                                  )
                                                },
                                                expression: "role.permissions",
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        {
                          staticClass:
                            "d-flex justify-content-end modal-buttons",
                          attrs: { md: "12" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "custom-modal-button mr-3",
                              on: { click: this.hideModal },
                            },
                            [
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t("message.cancel")) +
                                    "\n                        "
                                ),
                              ],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "custom-modal-button",
                              attrs: {
                                disabled: _vm.loading,
                                type: "submit",
                                variant: "primary",
                              },
                            },
                            [
                              !_vm.loading
                                ? [
                                    _vm.editMode
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(_vm.$t("message.update")) +
                                              "\n                            "
                                          ),
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(_vm.$t("message.save")) +
                                              "\n                            "
                                          ),
                                        ]),
                                  ]
                                : [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "spinner", spin: "" },
                                    }),
                                  ],
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }